import http from '../http';

// 复核状态
const fetchReviewReconStatus = (data) => {
  return http({
    url: `/recon/review-status`,
    method: 'POST',
    data,
  });
};

// 对账周期导出
const fetchExportRecon = (data) => {
  return http({
    url: `/recon/recon-contrast-data-export`,
    method: 'POST',
    responseType: 'blob',
    data,
  });
};

// 对账周期详情
const fetchReconDetail = (data) => {
  return http({
    url: `/recon/recon-detail`,
    method: 'POST',
    data,
  });
};

// 开票列表
const fetchInvoicesPage = (data) => {
  return http({
    url: `/invoices/logs/page`,
    method: 'POST',
    data,
  });
};

// 付款单修复
const fetchRepairPaymentBill = () => {
  return http({
    url: `/payment/type/fb/wechat/config`,
  });
};

// 付款单详情
const fetchPaymentBillDetail = (params) => {
  return http({
    url: `/transactions/payment-order/detail/${params.orderNo}`,
  });
};

// 获取账单列表
const fetchBillList = (data) => {
  return http({
    url: '/bills/items/search',
    method: 'POST',
    data,
  });
};

// 获取账单统计信息
const fetchBillStats = (params) => {
  return http({
    url: `/bill/order/${params.resvNo}`,
  });
};

// 获取全部账务项目
const fetchBillSubjects = () => {
  return http({
    url: '/subject/all',
  });
};

// 获取消费账务项目
const fetchConsumeSubjects = () => {
  return http({
    url: '/subject/buy',
  });
};

// 获取收款账务项目
const fetchPaymentSubjects = () => {
  return http({
    url: '/subject/pay',
  });
};

// 获取订单下所有房间
const fetchBillRooms = (data) => {
  return http({
    url: '/order/detail/list/sub-status',
    method: 'POST',
    data,
  });
};

// 生成入账/预结算业务订单
const generateBizOrder = (data) => {
  return http({
    url: '/bill/pay/order/submit',
    method: 'POST',
    data,
  });
};

// // 获取入账/预结算结果
// const fetchCreditResult = (params) => {
//   return http({
//     url: `/bill/pay/order/status/query/${params.bizNo}`,
//   });
// };

// 修改账单备注
const updateBillRemark = (data) => {
  return http({
    url: '/bills/items/remark',
    method: 'POST',
    data,
  });
};

// 生成结账单
const generateSettleOrder = (data) => {
  return http({
    url: '/settlements',
    method: 'POST',
    data,
  });
};

// 获取结账结果
const fetchSettleResult = (params) => {
  return http({
    url: `/settlements/status/${params.settlementNo}`,
  });
};

// 确认结账
const confirmSettle = (data) => {
  return http({
    url: '/settlements/confirm',
    method: 'POST',
    data,
  });
};

// 获取订单房主
const fetchOrderMaster = (params) => {
  return http({
    url: `/order/detail/summary/${params.resvNo}`,
  });
};

// 根据订单号获取房主信息
const fetchMasterInfoByOrderNo = (params) => {
  return http({
    url: `/order/detail/master/${params.resvNo}`,
  });
};

// 获取指定日期的日租房价
const fetchRoomRatebyDate = (data) => {
  return http({
    url: '/channels/roomType/retailPrice',
    method: 'POST',
    data,
  });
};

// 获取佣金率
const fetchCommissionRate = (data) => {
  return http({
    url: '/hotel-account-config/getCommissionRate',
    method: 'POST',
    data,
  });
};

// 获取子订单渠道
const getSubOrderChannel = (params) => {
  return http({
    url: '/sub/order/channel',
    method: 'GET',
    params,
  });
};

export {
  fetchReviewReconStatus,
  fetchExportRecon,
  fetchReconDetail,
  fetchInvoicesPage,
  fetchRepairPaymentBill,
  fetchPaymentBillDetail,
  fetchBillList,
  fetchBillStats,
  fetchBillSubjects,
  fetchConsumeSubjects,
  fetchPaymentSubjects,
  fetchBillRooms,
  updateBillRemark,
  generateBizOrder,
  // fetchCreditResult,
  generateSettleOrder,
  fetchSettleResult,
  confirmSettle,
  fetchOrderMaster,
  fetchMasterInfoByOrderNo,
  fetchRoomRatebyDate,
  fetchCommissionRate,
  getSubOrderChannel,
};
